export default "__VITE_ASSET__BpXM8eBl__"